// Gerado automaticamente — não editar manualmente
export const buildInfo = {
  version: '2.7.1',
  buildDate: '24/08/2026 18:56',
  gitHash: '987a0044'
};
